namespace advisorop.components.widgets {
    "use strict"
    export class AlertListXController {
        $router;
        public model: Array<domains.IAlertLog>;
        public dg: DevExpress.ui.dxDataGridOptions;
        n: number;
        public numberOfActiveAlerts;
        isServicer: boolean = false;
        currentServicerId: string;

        // input params
        householdId: number;
        accountGroupId: number;
        accountId: number;
        investorId: number;
        showArchived: boolean = false;
        adminMode: boolean = false;
        isUpdated = false;
        showUserEntry: boolean;
        showTasksWf: boolean;
        showTasksRm: boolean;
        showAll: boolean;
        panelTitle: string;
        showInformationalMessages: boolean = false;
        counters: domains.IAlertCounters;

        userEntryTask: domains.AlertsGetRule.SHOW_USER_ENTRY_TASKS;
        taskWorkflow: domains.AlertsGetRule.SHOW_TASK_WORKFLOW;
        taskRiskMonitor: domains.AlertsGetRule.SHOW_TASKS_RISK_MONITOR;
        allAlerts: domains.AlertsGetRule.SHOW_ALL;


        static $inject = ["generalService", "identityService", "advisorService", "$rootScope"];
        constructor(private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private advisorService: services.AdvisorService,
            private $rootScope: ng.IRootScopeService) {

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.loadAlerts();
            });

            this.userEntryTask = domains.AlertsGetRule.SHOW_USER_ENTRY_TASKS;
            this.taskWorkflow = domains.AlertsGetRule.SHOW_TASK_WORKFLOW;
            this.taskRiskMonitor = domains.AlertsGetRule.SHOW_TASKS_RISK_MONITOR;
            this.allAlerts = domains.AlertsGetRule.SHOW_ALL;

            this.$rootScope.$on('alertCounterChanged', (event: ng.IAngularEvent) => {
                this.counters = this.generalService.getAlertCounters();
            });
        }

        configureDataGrid(): void {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Alerts"
                },
                onExporting: function (e) {
                    e.component.columnOption("relatedAccountNumber", "visible", true);
                },
                onExported: function (e) {
                    e.component.columnOption("relatedAccountNumber", "visible", false);
                },
                bindingOptions: {
                    dataSource: "vm.model"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                stateStoring: {
                    enabled: false
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                noDataText: "No Tasks/Alerts",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "dateCreated", caption: "Occurred", cellTemplate: "colDate", width: 110, dataType: "datetime" },
                    //{ dataField: "relatedHousehold", caption:"Household(s)", width: 120 },
                    //{ dataField: "relatedInvestors", caption: "Individuals(s)", width: 120 },
                    { dataField: "relatedAccount", caption: "Title", width: 180, cellTemplate: "colAccount" },
                    { dataField: "relatedAccountNumber", caption: "Account Number", width: 120, visible: false },
                    //{ dataField: "accounts", caption: "Account(s)", width: 120 },
                    //{ dataField: "households", caption: "Household(s)", width: 120 },
                    //{ dataField: "investors", caption: "Investors(s)", width: 120 },
                    { dataField: "alertMessage", caption: "Message Text", encodeHtml: false, cellTemplate: "colMessage" },
                    { name: "hhInvestor", dataField: "relatedAccount", caption: "HH/Investor", width: 140, cellTemplate: "colHhInv" },
                    { dataField: "relatedAccountPrimaryAdvisorsStr", caption: "Primary Advisor(s)", width: 120 },
                    { dataField: "relatedAccountOfficeRangeDescription", caption: "Office Range", width: 120 },
                    { dataField: "statusDescription", caption: "Alert Status", width: 70 },
                    { dataField: "applicationDescription", caption: "System", width: 70, allowSearch: true },
                    { dataField: "severityDescription", caption: "Severity", width: 70, allowFiltering: true, allowSearch: true },
                    { dataField: "urlRouteForTaskAlert", caption: "Url", width: 60, visible: false },
                    {
                        dataField: "relatedServicer", caption: "Servicer", cellTemplate: "colServicer", width: 140, visible: true,
                        headerFilter: {
                            dataSource: function (data) {
                                data.dataSource.postProcess = function (resultsIn) {
                                    var resultsOut = [];
                                    resultsIn.forEach(function (result, i) {
                                        if (result.value == null) {
                                            resultsOut.push({ text: "Unclaimed", value: null })
                                        }
                                        else {
                                            resultsOut.push(result)
                                        }
                                    });
                                    return resultsOut;
                                }
                            },
                            allowSearch: true
                        }
                    },
                    { name: "action", dataField: "relatedServicer", caption: "Action", cellTemplate: "colClaimRelease", width: 60, visible: this.isServicer, allowFiltering: false, allowSearch: false },
                    { dataField: "id", caption: "Actions", cellTemplate: "colActions", width: 120, allowFiltering: false, allowSearch: false }
                ]
            };
        }

        onChangedOptionForArchivedAlerts(): void {
            this.showArchived = this.showArchived;
            this.loadAlerts(this.unversalVar);
        }

        getLogClass(alert: domains.IAlertLog): string {
            //console.log(alert);
            if (alert.severityId == domains.AlertSeverity.Warning)
                return "text-info";
            else if (alert.severityId == domains.AlertSeverity.Critical || alert.severityId == domains.AlertSeverity.Severe)
                return "text-danger";
            else if (alert.severityId == domains.AlertSeverity.FollowUpNeeded)
                return "text-info";
            else
                return "";
        }

        archiveAlert(alertLog: domains.IAlertLog): void {

            var x = this.model;

            console.log("ALERT LOG: ", alertLog);

            this.generalService.archiveAlert(alertLog)
                .success((data) => {
                    toastr.success("Alert has been archived.");
                    var ind = x.indexOf(alertLog);
                    if (ind >= 0) {
                        x.splice(ind, 1);
                        //this.numberOfActiveAlerts--;
                        //this.$rootScope.$broadcast("alertListChanged");
                        // in case if new alerts generated ...
                        this.generalService.refreshAlertCounters();
                        this.loadAlerts(this.unversalVar);
                    }
                })
                .error((data, status) => {
                    toastr.error("Can not archive this alert" + status + " " + data);
                });
        };

        claim(alertLog: domains.IAlertLog): void {
            this.generalService.claimAlert(alertLog)
                .success((data) => {
                    this.loadAlerts(this.unversalVar);
                })
                .error((data, status) => {
                    toastr.error("Could not claim alert. " + status + " " + data)
                })
        }

        release(alertLog: domains.IAlertLog): void {
            this.generalService.releaseAlert(alertLog)
                .success((data) => {
                    this.loadAlerts(this.unversalVar);
                })
                .error((data, status) => {
                    toastr.error("Could not release alert. " + status + " " + data)
                })
        }

        private isOwner(alertLog: domains.IAlertLog): boolean {
            return this.currentServicerId == alertLog.relatedServicerId;
        }

        canClaimed(alertLog: domains.IAlertLog): boolean {
            return this.isServicer && !this.isOwner(alertLog);
        }

        canRelease(alertLog: domains.IAlertLog): boolean {
            return this.isServicer && this.isOwner(alertLog);
        }

        servicerName(alertLog: domains.IAlertLog): string {
            if (alertLog.relatedServicer && alertLog.relatedServicer.length > 0) {
                return alertLog.relatedServicer;
            }
            return "Unclaimed";
        }

        unversalVar: domains.AlertsGetRule;

        loadAlerts(getRule: domains.AlertsGetRule = domains.AlertsGetRule.SHOW_ALL): void {
            this.adjustFlags(getRule);
            this.configureDataGrid();
            this.adminMode = this.advisorService.isAdminModeEnabled();
            this.generalService.getAlerts(this.showArchived, this.showInformationalMessages, this.householdId, this.accountGroupId, this.accountId, this.investorId, true, getRule)
                .then(data => {
                    this.model = data.data;
                    // console.log("ALERTI: ", this.model);
                    this.$rootScope.$on('alertCounterChanged', (event: ng.IAngularEvent) => {
                        this.counters = this.generalService.getAlertCounters();
                    });

                },
                    err => toastr.error("Alert list error: " + err.status + ":" + err.data));
        }

        //getInvestorsNames(investors: domains.IInvestor[]) {
        //    return Array.prototype.map.call(investors, item => item.fullName).join(", ");
        //}

        //getHouseholdsNames(households: domains.IHousehold[]) {
        //    return Array.prototype.map.call(households, item => item.name).join(", ");
        //}

        $onInit() {
            this.identityService.getUserPromise().then(response => {
                let user = response;
                // THIS IS NOT OK !!!!
                this.isServicer = user.systemLoginType == domains.SystemLoginType.SERVICER;
                this.currentServicerId = user.id;
                this.configureDataGrid()
            });
        }

        onChangeOptionForShowAlerts(option: domains.AlertsGetRule): void {
            if (option == domains.AlertsGetRule.SHOW_USER_ENTRY_TASKS) {
                this.loadAlerts(domains.AlertsGetRule.SHOW_USER_ENTRY_TASKS);
                this.panelTitle = "SERVICE REQUESTS";
            }
            else if (option == domains.AlertsGetRule.SHOW_ALL) {
                this.loadAlerts(domains.AlertsGetRule.SHOW_ALL);
                this.panelTitle = "ALL ALERTS";
            }
            else if (option == domains.AlertsGetRule.SHOW_TASKS_RISK_MONITOR) {
                this.loadAlerts(domains.AlertsGetRule.SHOW_TASKS_RISK_MONITOR);
                this.panelTitle = "RISK MONITOR ALERTS";
            }
            else if (option == domains.AlertsGetRule.SHOW_TASK_WORKFLOW) {
                this.loadAlerts(domains.AlertsGetRule.SHOW_TASK_WORKFLOW);
                this.panelTitle = "WORKFLOW TASKS";
            }
        }

        onChangedOptionForInformationalMessages(): void {
            this.showInformationalMessages = this.showInformationalMessages;
            this.loadAlerts(this.unversalVar);
        }

        storageKey(): string {
            return this.showAll ? "SHOWALL" : this.showTasksRm ? "TASKRM" : this.showTasksWf ? "TASKWF" : this.showUserEntry ? "USERENTRY" : "STORAGE";
        }

        adjustFlags(variable: domains.AlertsGetRule): void {
            this.showAll = (variable == domains.AlertsGetRule.SHOW_ALL);
            this.showTasksRm = (variable == domains.AlertsGetRule.SHOW_TASKS_RISK_MONITOR);
            this.showTasksWf = (variable == domains.AlertsGetRule.SHOW_TASK_WORKFLOW);
            this.showUserEntry = (variable == domains.AlertsGetRule.SHOW_USER_ENTRY_TASKS);
            this.unversalVar = variable;
            let dataGrid = $("#alertLogList").dxDataGrid("instance");
            if (dataGrid != undefined) {
                dataGrid.option("stateStoring.storageKey", this.storageKey());
            }
        }

        $onChanges(evt): void {
            for (var key in evt) {

                // console.log("onChanges fired for key " + key + "=" + this[key]);
                if (key == "showUserEntry" && this.showUserEntry) {
                    //console.log("Loading user entry logs");
                    this.loadAlerts(domains.AlertsGetRule.SHOW_USER_ENTRY_TASKS);
                } else if (key == "showTasksWf" && this.showTasksWf) {
                    //console.log("Loading user tasks wf logs");
                    this.loadAlerts(domains.AlertsGetRule.SHOW_TASK_WORKFLOW);
                } else if (key == "showTasksRm" && this.showTasksRm) {
                    //console.log("Loading user rm logs");
                    this.loadAlerts(domains.AlertsGetRule.SHOW_TASKS_RISK_MONITOR);
                } else if (key == "showAll" && this.showAll) {
                    //console.log("Loading all logs");
                    this.loadAlerts(domains.AlertsGetRule.SHOW_ALL);
                } else if (!this.showArchived && !this.showTasksRm && !this.showTasksWf && !this.showUserEntry && !this.showAll) {
                    //console.log("Loading all logs");
                    this.showAll = true;
                    this.loadAlerts(domains.AlertsGetRule.SHOW_ALL);
                }

                if (key == "panelTitle") {
                    if (!this.panelTitle) {
                        this.panelTitle = "SERVICE REQUESTS";
                    }
                }

            }
        }

        $routerOnActivate(next, previous) {
        }
    }

    class AlertList implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<",
                householdId: "<",
                accountGroupId: "<",
                accountId: "<",
                investorId: "<",
                n: "<",
                showUserEntry: "<",
                showTasksWf: "<",
                showTasksRm: "<",
                showAll: "<",
                panelTitle: "@"
            };
            this.controller = AlertListXController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/shared/common/alert-list.html";
        }
    }
    angular.module(Constants.APP).component("alertList", new AlertList());
}